import React, { FC, useState } from 'react';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { IconButton, Tooltip } from '@mui/material';

import { emailLinkedPaths } from '@pharmaplan/common';

import { showError } from '../Profile/Pharmacist/PharmacistViewProfile/helper';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { buildLandingUrl } from '../../../helpers/Functions';
import strings from '../../../localization';

import styles from './styles';

interface ICopyShiftUrlButton {
  workshiftId: string;
  isAutoSyncRecord: boolean;
}

const CopyShiftUrlButton: FC<ICopyShiftUrlButton> = ({
  workshiftId,
  isAutoSyncRecord,
}) => {
  const dispatch = useAppDispatch();

  const [isCopied, setIsCopied] = useState(false);

  const shiftUrl = buildLandingUrl(emailLinkedPaths.workshiftDetails, {
    id: workshiftId,
    isExternal: String(isAutoSyncRecord),
  });

  const handleCopy = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    navigator.clipboard
      .writeText(shiftUrl)
      .then(() =>
        setIsCopied(true))
      .catch(() =>
        showError(dispatch, strings.unableToCopyShiftLink));
  };

  const resetCopiedState = () =>
    setIsCopied(false);

  return (
    <Tooltip
      title={isCopied ? strings.shiftLinkCopied : strings.copyShiftLink}
      onClose={resetCopiedState}
    >
      <IconButton
        aria-label={strings.copyShiftLink}
        onClick={handleCopy}
        sx={styles.copyButton}
      >
        <ContentCopyIcon sx={styles.copyIcon} />
      </IconButton>
    </Tooltip>
  );
};

export default CopyShiftUrlButton;
